import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VueClipboard from 'vue-clipboard2'

Vue.use(Vuetify);
Vue.use(VueClipboard)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
});
